import React from 'react'
import PropTypes from 'prop-types'
import moment from '../../helpers/momentUtils'

const OffersCarouselItem = ({ flight, handleClick, active }) => {
  const departureTime = moment(flight.departureDateTime).format('H:mm')
  const arrivalTime = moment(flight.arrivalDateTime).format('H:mm')
  const flightPeriod = `${departureTime} - ${arrivalTime}`
  const className = active
    ? 'OffersCarousel__button -active'
    : 'OffersCarousel__button'

  return (
    <button className={className} onClick={handleClick}>
      {flightPeriod}
    </button>
  )
}

OffersCarouselItem.propTypes = {
  flight: PropTypes.object,
  handleClick: PropTypes.func,
  active: PropTypes.bool,
}

export default OffersCarouselItem
